/* ANCHOR theme — minimal vanilla JS, no build step, no dependencies. */
(function () {
  "use strict";

  /* Mobile nav toggle ----------------------------------------------------- */
  function initMobileNav() {
    var toggle = document.querySelector("[data-menu-toggle]");
    var nav = document.querySelector("[data-mobile-nav]");
    if (!toggle || !nav) return;
    toggle.addEventListener("click", function () {
      var isOpen = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  }

  /* Reveal-on-scroll (clean fade/slide only) -------------------------------- */
  function initReveal() {
    var items = document.querySelectorAll(".reveal");
    if (!items.length || !("IntersectionObserver" in window)) return;

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var toObserve = [];

    items.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var alreadyInView = rect.top < viewportHeight && rect.bottom > 0;
      if (alreadyInView) return; // leave fully visible — no dependency on JS timing for above-the-fold content
      el.classList.add("js-pending");
      toObserve.push(el);
    });

    if (!toObserve.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            entry.target.classList.remove("js-pending");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
    );
    toObserve.forEach(function (el) { observer.observe(el); });
  }

  /* FAQ accordions (native <details>, JS only closes siblings) ------------- */
  function initFaq() {
    var items = document.querySelectorAll("[data-faq-item]");
    items.forEach(function (item) {
      item.addEventListener("toggle", function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  /* Product gallery thumbnail sync (main product section) ------------------ */
  function initGallery(root) {
    var main = root.querySelector("[data-gallery-main]");
    var thumbs = root.querySelectorAll("[data-gallery-thumb]");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-full-src");
        if (!src) return;
        main.src = src;
        thumbs.forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  }

  /* Sticky mobile Add to Cart bar -------------------------------------------- */
  function initStickyAtc() {
    var bar = document.querySelector("[data-sticky-atc]");
    var anchorForm = document.querySelector("[data-product-form]");
    if (!bar || !anchorForm) return;

    if (!("IntersectionObserver" in window)) {
      bar.classList.add("is-visible");
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle("is-visible", !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(anchorForm);

    var stickyButton = bar.querySelector("[data-sticky-atc-button]");
    if (stickyButton) {
      stickyButton.addEventListener("click", function () {
        var mainSubmit = anchorForm.querySelector("[type='submit']");
        if (mainSubmit) mainSubmit.click();
      });
    }
  }

  /* Keep sticky bar price and the main gallery image in sync with the variant picker */
  function initVariantSync(root) {
    var form = root.querySelector("[data-product-form]");
    var stickyPrice = document.querySelector("[data-sticky-atc-price]");
    var mainImage = root.querySelector("[data-gallery-main]");
    var thumbs = root.querySelectorAll("[data-gallery-thumb]");
    if (!form) return;

    var radios = form.querySelectorAll("input[data-variant-id]");
    if (!radios.length) return;

    radios.forEach(function (radio) {
      radio.addEventListener("change", function () {
        var price = radio.getAttribute("data-variant-price");
        if (price && stickyPrice) stickyPrice.textContent = price;

        var variantImage = radio.getAttribute("data-variant-image");
        if (variantImage && mainImage) {
          mainImage.src = variantImage;
          thumbs.forEach(function (thumb) {
            thumb.classList.toggle("is-active", thumb.getAttribute("data-full-src") === variantImage);
          });
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initMobileNav();
    initReveal();
    initFaq();
    initStickyAtc();
    document.querySelectorAll("[data-gallery-root]").forEach(function (root) {
      initGallery(root);
      initVariantSync(root);
    });
  });
})();
